import { render } from "./UpdateApp.vue?vue&type=template&id=5cc4c2c9&scoped=true&ts=true"
import script from "./UpdateApp.vue?vue&type=script&lang=ts"
export * from "./UpdateApp.vue?vue&type=script&lang=ts"

import "./UpdateApp.vue?vue&type=style&index=0&id=5cc4c2c9&lang=scss&scoped=true"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc4c2c9"]])

export default __exports__